import _ from 'lodash';
import React, { Component } from 'react';
import { EDITOR_CONTAINER_ID, EDIT_MAIN_WRAPPER_ID } from 'crazyEditor/core/constants/editorConstants';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Radium from 'radium';
import styles from './MainStyles';
import { STAGGER_DURATION } from 'crazyEditor/components/common/firstRenderAnimationStyles';
import Toolbar from 'crazyEditor/components/Toolbar/Toolbar';
import EditorLeftBar from './EditorLeftBar';
import EditorStage from 'crazyEditor/components/EditorStage/EditorStage';
import ElementControls from './ElementControls';
import EditorDialogs from './EditorDialogs';
import OpenedLazyPanels from './OpenedLazyPanels';
import { setStageLayout } from 'crazyEditor/redux/modules/stage/stage';
import {setFullScreen} from 'shared/components/Integration/IntegrationUtils';
import {getPageElementLayout} from 'crazyEditor/redux/modules/element/elementSelectors';
import { getStageLayout } from 'crazyEditor/core/utils/stageUtils';
import {MESSAGE_TYPE} from 'shared/components/Integration/IntegrationConsts';
import shallowEqual from 'fbjs/lib/shallowEqual';
import EditorWalkThroughWrapper from 'shared/components/WalkThrough/EditorWalkThroughWrapper';

@connect(
  (state) => ({
    isMobileView: state.editor.isMobileView,
    isDesktopView: state.editor.isDesktopView,
    isPreviewMode: state.editor.isPreviewMode,
    pageElementLayout: getPageElementLayout(state),
    stageLayout: state.stage.layout
  }),
  {setStageLayout}
)
@Radium
export default class Main extends Component {

  static contextTypes = {
    integrationConnector: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      loadStep: null,
    };
  }

  componentWillMount() {
    const { setStageLayout, pageElementLayout } = this.props;
    setStageLayout(getStageLayout(pageElementLayout));

    setFullScreen(this.context.integrationConnector, true);
  }

  componentDidMount() {
    const { setStageLayout, pageElementLayout } = this.props;
    _.defer(() => setStageLayout(getStageLayout(pageElementLayout)));
    window.addEventListener('resize', this.updateStageLayout);
    this.delayedSetState({loadStep: 0}, 0);
    _.defer(() => {
      this.context.integrationConnector.sendMessage({type: MESSAGE_TYPE.ROOT_COMPONENT_MOUNTED});
    });
  }

  componentDidUpdate(prevProps) {
    const relevantProps = ['pageElementLayout', 'isPreviewMode', 'isDesktopView', 'isMobileView'];
    if (!shallowEqual(_.pick(prevProps, relevantProps), _.pick(this.props, relevantProps))) {
      this.updateStageLayout();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateStageLayout);
    setFullScreen(this.context.integrationConnector, false);
  }

  updateStageLayout = () => {
    const { stageLayout, pageElementLayout, setStageLayout } = this.props;
    const newStageLayout = getStageLayout(pageElementLayout);
    if (!_.isEqual(stageLayout, newStageLayout)) {
      setStageLayout(newStageLayout);
    }
  };

  delayedSetState = (state, delay) => window.setTimeout(() => {
    this.setState(state);
  }, delay);

  render() {
    const { isMobileView, isDesktopView, isPreviewMode } = this.props;

    return (
      <div id={EDIT_MAIN_WRAPPER_ID} style={{width: '100%', height: '100%'}}>
        {!isPreviewMode && <EditorWalkThroughWrapper/>}
        <Toolbar {...this.props}/>
        <div id={EDITOR_CONTAINER_ID} onTransitionEnd = {this.updateStageLayout} style={[styles.editorContainer, isPreviewMode && styles.previewMode]}>
          {!isPreviewMode && <EditorLeftBar isMobileView={isMobileView} isDesktopView={isDesktopView}/>}
          <EditorStage />
          {!isPreviewMode && <ElementControls isMobileView={isMobileView} isDesktopView={isDesktopView}/>}
          <EditorDialogs />
        </div>
        <OpenedLazyPanels/>
      </div>
    );
  }
}